<template>
  <v-card flat>
    <v-card-title class="title-font">
      PHOTOGRAMMETRY EXPORT FILE <v-spacer />
      <div
        v-if="showErrors && !photogrammetryLibExport"
        class="error--text text-body-2"
      >
        <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
        <span> Please make a selection </span>
      </div>
    </v-card-title>
    <v-card-subtitle class="pb-0">
      What library export did you choose on the scanning device?
    </v-card-subtitle>
    <v-card-text class="pa-4">
      <v-autocomplete
        v-model="photogrammetryLibExport"
        :items="mappedHealingCaps"
        dense
        outlined
        hide-details
        :menu-props="{ rounded: '10' }"
        placeholder="Photogrammetry Export File"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import client from "@/lib/ApiClient"

export default {
  name: "PhotogrammetryLibExport",

  props: ["value"],

  inject: ["form"],

  data() {
    return {
      showErrors: false
    }
  },

  computed: {
    ...mapGetters(["exportComponents"]),

    photogrammetryLibExport: {
      get() {
        return this.value
      },
      set(val) {
        this.showErrors = false
        this.$emit("input", val)
      }
    },

    mappedHealingCaps() {
      if (!this.exportComponents) return []
      const healingCaps = this.exportComponents
        .filter((c) => c.type === "Healing Cap")
        .map((c) => {
          return {
            text: c.name,
            value: c.code
          }
        })
      healingCaps.unshift({
        text: "Default Photogrammetry Export (Scan Flag/Scan Body/Domino)",
        value: "default_photogrammetry_export"
      })
      return healingCaps
    }
  },

  methods: {
    ...mapActions(["setExportComponents"]),
    validate() {
      if (!this.photogrammetryLibExport) this.showErrors = true
      this.valid = !!this.photogrammetryLibExport
      return !!this.photogrammetryLibExport
    },

    async fetchExportComponents() {
      this.loading = true
      this.setExportComponents(
        await client.gateway.components.fetchExportComponents()
      )
      this.loading = false
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
